import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CurrencyCode, CurrencySymbol } from 'src/app/models/country-code-mapper';

@Component({
  selector: 'app-pricing-plan',
  templateUrl: './pricing-plan.component.html',
  styleUrls: ['./pricing-plan.component.scss'],
})
export class PricingPlanComponent implements OnInit {
  @Input()
  mostPopular: boolean;

  @Input()
  creditsToPurchase: number;

  @Input()
  cost: number;

  @Input()
  currencyCode: CurrencyCode;

  @Input()
  currencySymbol: CurrencySymbol;

  @Output()
  buttonClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  buyClicked(event) {
    this.buttonClick.emit(event);
  }
}
